interface INW_FORMULA {
  shares: number;
  income: number;
  cashBank: number;
  estate: number;
  gold: number;
  otherA: number;
  homeLoan: number;
  personalLoan: number;
  bills: number;
  creditCard: number;
  otherL: number;
  assetGrowth: number;
  liabilityGrowth: number;
  years: number;
}
export const NW_FORMULA = ({
  shares,
  income,
  cashBank,
  estate,
  gold,
  otherA,
  homeLoan,
  personalLoan,
  bills,
  creditCard,
  otherL,
  assetGrowth,
  liabilityGrowth,
  years,
}: INW_FORMULA) => {
  const sha = Number(shares);
  const inc = Number(income);
  const cash = Number(cashBank);
  const est = Number(estate);
  const g = Number(gold);
  const oA = Number(otherA);
  const home = Number(homeLoan);
  const personal = Number(personalLoan);
  const bill = Number(bills);
  const credit = Number(creditCard);
  const oL = Number(otherL);
  const assetGrow = Number(assetGrowth);
  const liabilityGrow = Number(liabilityGrowth);
  const year = Number(years);
  if (
    sha < 0 ||
    sha > 1e10 ||
    inc < 0 ||
    inc > 1e10 ||
    cash < 0 ||
    cash > 1e10 ||
    est < 0 ||
    est > 1e10 ||
    g < 0 ||
    g > 1e10 ||
    oA < 0 ||
    oA > 1e10 ||
    home < 0 ||
    home > 1e10 ||
    personal < 0 ||
    personal > 1e10 ||
    bill < 0 ||
    bill > 1e10 ||
    credit < 0 ||
    credit > 1e10 ||
    oL < 0 ||
    oL > 1e10
  ) {
    const emptyRes = 0;
    return {
      noOfYears: 0,
      aGrow: '0',
      lGrow: '0',
      netWorth: emptyRes.toFixed(0),
      totalAssets: emptyRes.toFixed(0),
      totalLiabilities: emptyRes.toFixed(0),
    };
  }
  const asset = sha + inc + cash + est + g + oA;
  const lia = home + personal + bill + credit + oL;
  const nw = asset - lia;
  return {
    noOfYears: year,
    aGrow: assetGrow.toFixed(0),
    lGrow: liabilityGrow.toFixed(0),
    netWorth: nw.toFixed(0),
    totalAssets: asset.toFixed(0),
    totalLiabilities: lia.toFixed(0),
  };
};
